import { ButtonIcon } from 'shared';

import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';

import { ScheduleIcon } from './ScheduleIcon';

export const ChatMessageViewScheduledMessagesButton = () => {
  const { showScheduledMessages } = useChatMessageSchedulingContext();

  return (
    <ButtonIcon
      aria-label="open scheduled messages button"
      onClick={showScheduledMessages}
    >
      <ScheduleIcon withDot />
    </ButtonIcon>
  );
};
